import React from 'react';

interface UserStats {
  totalGoals: number;
  totalAssists: number;
  totalSaves: number;
  totalMatches: number;
  totalWins: number;
  totalLosses: number;
  totalDraws: number;
  mvpCount: number;
  topScorerCount: number;
  topAssisterCount: number;
  topSaverCount: number;
}

interface ProfileStatsProps {
  stats: UserStats | null;
  isMobile?: boolean;
}

export const ProfileStats: React.FC<ProfileStatsProps> = ({
  stats,
  isMobile = false
}) => {
  return (
    <div style={{ marginBottom: '20px' }}>
      <h3 style={{ 
        fontSize: isMobile ? '15px' : '18px', 
        fontWeight: 'bold', 
        margin: '0 0 10px 0', 
        color: '#FFFFFF' 
      }}>
        📊 Logros
      </h3>
      <div style={{ 
        display: 'flex', 
        gap: isMobile ? '8px' : '18px', 
        flexWrap: 'wrap' 
      }}>
        {/* MVP */}
        <div style={{
          flex: 1,
          minWidth: isMobile ? '110px' : '150px',
          background: 'linear-gradient(90deg, #FFD600 0%, #FFF9C4 100%)',
          border: '1.5px solid #FFD600',
          borderRadius: '14px',
          boxShadow: '0 1px 4px #FFD60033',
          color: '#181A1B',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '10px 0' : '18px 0',
          fontWeight: 700,
          fontSize: isMobile ? '13px' : '18px',
          letterSpacing: '0.04em',
        }}>
          <span style={{ fontSize: isMobile ? '18px' : '28px', marginBottom: '6px' }}>👑</span>
          <span style={{ fontSize: isMobile ? '20px' : '32px', fontWeight: 800 }}>{stats?.mvpCount ?? 0}</span>
          <span style={{ fontSize: isMobile ? '11px' : '14px', fontWeight: 600, marginTop: '2px' }}>MVP</span>
        </div>
        
        {/* Goleador */}
        <div style={{
          flex: 1,
          minWidth: isMobile ? '110px' : '150px',
          background: 'linear-gradient(90deg, #00E676 0%, #B2FF59 100%)',
          border: '1.5px solid #00E676',
          borderRadius: '14px',
          boxShadow: '0 1px 4px #00E67633',
          color: '#181A1B',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '10px 0' : '18px 0',
          fontWeight: 700,
          fontSize: isMobile ? '13px' : '18px',
          letterSpacing: '0.04em',
        }}>
          <span style={{ fontSize: isMobile ? '18px' : '28px', marginBottom: '6px' }}>⚽</span>
          <span style={{ fontSize: isMobile ? '20px' : '32px', fontWeight: 800 }}>{stats?.topScorerCount ?? 0}</span>
          <span style={{ fontSize: isMobile ? '11px' : '14px', fontWeight: 600, marginTop: '2px' }}>Goleador</span>
        </div>
        
        {/* Asistidor */}
        <div style={{
          flex: 1,
          minWidth: isMobile ? '110px' : '150px',
          background: 'linear-gradient(90deg, #7C4DFF 0%, #E1BEE7 100%)',
          border: '1.5px solid #7C4DFF',
          borderRadius: '14px',
          boxShadow: '0 1px 4px #7C4DFF33',
          color: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '10px 0' : '18px 0',
          fontWeight: 700,
          fontSize: isMobile ? '13px' : '18px',
          letterSpacing: '0.04em',
        }}>
          <span style={{ fontSize: isMobile ? '18px' : '28px', marginBottom: '6px' }}>➡️</span>
          <span style={{ fontSize: isMobile ? '20px' : '32px', fontWeight: 800 }}>{stats?.topAssisterCount ?? 0}</span>
          <span style={{ fontSize: isMobile ? '11px' : '14px', fontWeight: 600, marginTop: '2px' }}>Asistidor</span>
        </div>
        
        {/* Guante de Oro */}
        <div style={{
          flex: 1,
          minWidth: isMobile ? '110px' : '150px',
          background: 'linear-gradient(90deg, #00B8D9 0%, #81D4FA 100%)',
          border: '1.5px solid #00B8D9',
          borderRadius: '14px',
          boxShadow: '0 1px 4px #00B8D933',
          color: '#181A1B',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: isMobile ? '10px 0' : '18px 0',
          fontWeight: 700,
          fontSize: isMobile ? '13px' : '18px',
          letterSpacing: '0.04em',
        }}>
          <span style={{ fontSize: isMobile ? '18px' : '28px', marginBottom: '6px' }}>🧤</span>
          <span style={{ fontSize: isMobile ? '20px' : '32px', fontWeight: 800 }}>{stats?.topSaverCount ?? 0}</span>
          <span style={{ fontSize: isMobile ? '11px' : '14px', fontWeight: 600, marginTop: '2px' }}>Guante de Oro</span>
        </div>
      </div>
    </div>
  );
}; 